export module ObjectHelpers {
 /**
  * only works for primitive types send list of int not an object with multiple properties 
  * @param arr
  * @returns
  */
  export function hasDuplicates<T>(arr: T[]): boolean {
    return new Set(arr).size < arr.length;
  }


}
